export const INTAKE_SOURCE_FORM_CAPTURE = 'form-capture'
export const INTAKE_SOURCE_EMAIL_CAPTURE = 'email-capture'
export const INTAKE_SOURCE_HUBSPOT = 'hubspot'
export const INTAKE_SOURCE_PIPEDRIVE = 'pipedrive'
export const INTAKE_SOURCE_ZOHO = 'zoho'
export const INTAKE_SOURCE_GUESTY = 'guesty'
export const INTAKE_SOURCE_FACEBOOK = 'facebook'
export const INTAKE_SOURCE_IMPORTS = 'imports'
export const INTAKE_SOURCE_VOIP_CALL = 'voip-call'
export const INTAKE_SOURCE_VOIP_SMS = 'voip-sms'
export const INTAKE_SOURCE_UI = 'ui'
export const INTAKE_SOURCE_MCP = 'mcp'

export const IntakeSources = [
    {
        'code': INTAKE_SOURCE_FORM_CAPTURE,
        'name': 'Form Capture'
    },
    {
        'code': INTAKE_SOURCE_EMAIL_CAPTURE,
        'name': 'Email Capture'
    },
    {
        'code': INTAKE_SOURCE_HUBSPOT,
        'name': 'HubSpot'
    },
    {
        'code': INTAKE_SOURCE_PIPEDRIVE,
        'name': 'Pipedrive'
    },
    {
        'code': INTAKE_SOURCE_ZOHO,
        'name': 'ZohoCRM'
    },
    {
        'code': INTAKE_SOURCE_GUESTY,
        'name': 'Guesty'
    },
    {
        'code': INTAKE_SOURCE_FACEBOOK,
        'name': 'Facebook'
    },
    {
        'code': INTAKE_SOURCE_IMPORTS,
        'name': 'Imports'
    },
    {
        'code': INTAKE_SOURCE_VOIP_CALL,
        'name': 'Call'
    },
    {
        'code': INTAKE_SOURCE_VOIP_SMS,
        'name': 'Sms'
    },
    {
        'code': INTAKE_SOURCE_UI,
        'name': 'Manual'
    },
    {
        'code': INTAKE_SOURCE_MCP,
        'name': 'MCP'
    },
]
